import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import * as _ from 'lodash';
import { AppService } from 'src/@core/services/app.service';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[showIfPermission]'
})
export class ShowIfPermissionDirective implements OnInit {

  // tslint:disable-next-line:variable-name
  private _permissions: string[];
  constructor(private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private appService: AppService
  ) { }

  @Input() set showIfPermission(permissions: string[]) {
    // console.log("##########", permissions);
    this._permissions = permissions || []; // Initialize to an empty array if undefined
  }

  ngOnInit(): void {
    this.appService.currentUser.subscribe((currentUser: any) => {
      // console.log("$$$$$$$$$$$$$$$$", currentUser);
      if (!currentUser) {
        this.viewContainer.clear();
        return;
      }

      // Flatten currentUser.permissions
      if (currentUser.permissions) {
        const flatCurrentUserPermissions = currentUser.permissions.flat();

        // Check if _permissions is empty or contains any permissions from flatCurrentUserPermissions
        const permissionsAreEmpty = this._permissions.length === 0;
        // console.log("Permissions are empty:", permissionsAreEmpty);

        const hasMatchingPermissions = this._permissions.some(permission =>
          flatCurrentUserPermissions.includes(permission)
        );
        // console.log("Has matching permissions:", hasMatchingPermissions);

        const shouldShowSection = permissionsAreEmpty || hasMatchingPermissions;
        // console.log("Should show section:", shouldShowSection);

        if (shouldShowSection) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      } else {
        this.viewContainer.clear();
      }
    });
  }

}
